
<template>
  <div class="AppRoot" :class="{'global-theme': true}">
    <AppHeader/>

    <!-- <Auth v-if="authOverlay" @close="authOverlay = false"/> -->
    <Auth v-if="!!$store.getters.username"/>
    <router-view v-else/>

  </div>
</template>

<script>
  import Auth from '@/components/Auth/Auth.vue';
  import AppHeader from '@/components/header/AppHeader.vue';
  export default {
    name: 'App',
    components: {
      Auth,
      AppHeader,
    },
    data() {
      return {
        authOverlay: false,
      };
    },
    beforeMount() {
      this.$store.dispatch('user/initialize')
        .then(() => console.log('store.user initialized'));
    },
    inject: {
      $client: {
        from: 'client',
      }
    },
    methods: {
      async fetchDashboard() {
        const res = await this.$client.get('/dashboard/');
        console.log('DB', res);
      },
    },
  }
</script>

<style lang="scss" src="@/styles/base"></style>
<style lang="scss">
  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;
    }
  }
</style>
